export default __webpack_public_path__ + "static/media/logo-light.a9a6a3d4.svg";